import { ServerAPI } from "../actions/serverAPI";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { adminStore } from "../stores/adminStore";
import { converters } from "../util/converters";
const { ActionTypes } = Constants;

export const AdminActions = {
  setItemType(type) {
    dispatcher.dispatch({
      type: ActionTypes.SET_ADMIN_ITEM_TYPE,
      itemType: type,
    });
  },
  loadItems() {
    dispatcher.dispatch({
      type: ActionTypes.LOAD_ADMIN_ITEMS_STARTED,
    });
    var orUserCall;
    var type = adminStore.getItemType();
    switch (type) {
      case "/defaultTracks":
        orUserCall = ServerAPI.getDefaultTracks();
        break;
      case "/reasonCodes":
        orUserCall = ServerAPI.getReasonCodes();
        break;
      case "/gritUser":
        orUserCall = ServerAPI.getUserDetails();
        break;
      case "/outageList":
        orUserCall = ServerAPI.getOutageList();
        break;
      case "/override":
        orUserCall = ServerAPI.getOverrideUsers();
        break;
      case "/patternsMaintenance":
        orUserCall = ServerAPI.getPatternMaintenance();
        break;
    }

    if (!orUserCall) {
      return;
    }

    orUserCall
      .done(function success(data) {
        if (Array.isArray(data)) {
          dispatcher.dispatch({
            type: ActionTypes.LOAD_ADMIN_ITEMS_DONE,
            items: data,
          });
        } else if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.LOAD_ADMIN_ITEMS_DONE,
            items: data.data.map(function (or) {
              return converters.convertOverrideToClientFormat(or);
            }),
          });
        } else {
          console.log("error state", data);
          dispatcher.dispatch({
            type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
            error: data.errors[0].message,
          });
        }
      })
      .fail(function failed(xhr, status, error) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      });
  },
  cellValueChanged: function (row, id, value) {
    dispatcher.dispatch({
      type: ActionTypes.CELL_UPDATED,
      id: id,
      value: value,
      row: row,
    });
  },
  inputBlurred: function (e, inputRow) {
    dispatcher.dispatch({
      type: ActionTypes.NEW_ADMIN_ROW_ENTERED,
      data: inputRow,
      buttonClicked: false,
    });
  },
  submitNewOverride: function (override) {
    dispatcher.dispatch({
      type: ActionTypes.NEW_ADMIN_ROW_ENTERED,
      data: override,
      buttonClicked: true,
    });

    if (adminStore.canSubmitAdminItem()) {
      var serverCall = ServerAPI.submitNewOverrideUser(override);

      serverCall
        .done(function (data) {
          if (data.success) {
            dispatcher.dispatch({
              type: ActionTypes.NEW_OVERRIDE_SUBMITTED,
              override: converters.convertOverrideToClientFormat(data.data),
            });
          } else {
            dispatcher.dispatch({
              type: ActionTypes.ADMIN_ITEM_SUBMIT_ERROR,
              errors: data.errors,
            });
            console.log("error occurred submitting override", data);
          }
        })
        .fail(function (error, xhr) {
          console.error("error occurred submitting override", error, xhr);
        });
    } else {
      console.log("Admin Item is invalid");
    }
  },
  expireExistingOverride: function (id) {
    var serverCall = ServerAPI.expireOverrideUser(id);

    serverCall
      .done(function (data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.EXISTING_OVERRIDE_EXPIRED,
            override: converters.convertOverrideToClientFormat(data.data),
          });
        } else {
          console.log("error occurred submitting override", data);
        }
      })
      .fail(function (error, xhr) {
        console.error("error occurred submitting override", error, xhr);
      });
  },
  submitNewDefaultTrack: function (track) {
    var serverCall = ServerAPI.updateDefaultTrack(track);

    serverCall
      .done(function success(data) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_DONE,
          items: data.data.map(function (or) {
            return converters.convertOverrideToClientFormat(or);
          }),
        });
      })
      .fail(function failed(xhr, status, error) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      });
  },
  submitNewReasonCode: function (reasonCode) {
    var serverCall = ServerAPI.updateReasonCode(reasonCode);

    serverCall
      .done(function success(data) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_DONE,
          items: data.data.map(function (or) {
            return converters.convertOverrideToClientFormat(or);
          }),
        });
      })
      .fail(function failed(xhr, status, error) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      });
  },

  submitNewGritUser: function (gritUser) {
    var serverCall = ServerAPI.updateGritUser(gritUser);

    serverCall
      .done(function success(data) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_DONE,
          items: data.data.map(function (or) {
            return converters.convertOverrideToClientFormat(or);
          }),
        });
      })
      .fail(function failed(xhr, status, error) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      });
  },
  //Ading new pattern
  submitNewPatternMaint: (patternData) => {
    return ServerAPI.updatePatternMaint(patternData).fail(
      (xhr, status, error) => {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      }
    );
  },
  updateNewPatternMaint: function (patternData) {
    return ServerAPI.updateExistingPatternMaint(patternData).fail(
      (xhr, status, error) => {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      }
    );
  },

  //Delete new pattern
  deletePatternMaint: function (patternId) {
    return ServerAPI.deletePatternMaint(patternId).fail(
      (xhr, status, error) => {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      }
    );
  },

  deleteGritUserDetail: function (bNumber) {
    ServerAPI.deleteGritUser(bNumber)
      .done(function success(data) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_DONE,
          items: data.data.map(function (or) {
            return converters.convertOverrideToClientFormat(or);
          }),
        });
      })
      .fail(function failed(xhr, status, error) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      });
  },

  deleteDefaultTrack: function (trackId) {
    ServerAPI.deleteDefaultTrack(trackId)
      .done(function success(data) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_DONE,
          items: data.data.map(function (or) {
            return converters.convertOverrideToClientFormat(or);
          }),
        });
      })
      .fail(function failed(xhr, status, error) {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_ADMIN_ITEMS_ERROR,
          error: error,
        });
      });
  },
};
